import React, { useCallback, useContext } from 'react';
import PropTypes from 'prop-types';
import { renderContentFromMetadata } from '@jutro/uiconfig';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
// eslint-disable-next-line import/no-unresolved
import metadata from './PageFooterComponent.metadata.json5';
import pageFooterStyles from './PageFooterComponent.module.scss';
import appConfig from 'app-config';
import messages from './../PageHeaderComponent/PageHeaderComponent.messages';
import { TranslatorContext } from '@jutro/locale';


function PageFooterComponent() {
    const { env } = appConfig;     
    const translator = useContext(TranslatorContext);

    const getLogoSrc = useCallback(() => {
        const url = _.get(env, 'DEPLOYMENT_URL');
        const logoUrl = `${url}/branding/AyrFooterLogo.svg`       
       return logoUrl;
    }, [env]);

    const getFooterLinkUrl = useCallback((pageName) => {
        const url = _.get(env, 'DEPLOYMENT_URL');
        const footerUrl = `${url}/${pageName}`       
       return footerUrl;
    }, [env]);

    const getNavLinks = () => {
        const termsAndConditionsLink = "https://www.ayrmutual.com/site/privacy-code" ;
        const privacyPolicyLink = "https://www.ayrmutual.com/about/privacy-statement.html";
        const complaintHandlingLink = "https://www.ayrmutual.com/site/complaint-handling-protocol";
        return(
            <div>
                <a
                 target="_blank" href= {termsAndConditionsLink} aria-label="termsAndConditions"
                  id="termsAndConditions">{translator(messages.termsAndConditions)}</a>
                <a
                 target="_blank" href={privacyPolicyLink} aria-label="privacyPolicy"
                  id="privacyPolicy" className={pageFooterStyles.privacyPolicy}>{translator(messages.privacyPolicy)}</a>
                <a
                 target="_blank" href={complaintHandlingLink} aria-label="complaintHandling"
                  id="complaintHandling">{translator(messages.complaintHandling)}</a>
            </div>
            )
    }

    const overrides = {
        footerLogoImage: {
            src: getLogoSrc()
        },
        customfooterNavBar:{
            content: getNavLinks()
        },
        footerCopyrightContent: {
            messageProps: {copyrightMessage: translator(messages.ayrCopyrightMesssage)}
        }

    };

    const resolvers = {
        resolveClassNameMap: pageFooterStyles
    };

    return renderContentFromMetadata(metadata.componentContent, overrides, resolvers);
}

PageFooterComponent.propTypes = {
    routes: PropTypes.arrayOf(PropTypes.shape({})).isRequired
};

export default withRouter(PageFooterComponent);
